export const actionTypes = {
  ON_LOGIN_LOADING: "on-login-loading",
  ON_LOGIN_ERR: "on-login-err",
  ON_LOGIN_SUCCESS: "on-login-success",
  ON_LOGOUT: "on-logout",
};

export const initialState = {
  users: [],
  loginLoading: false,
  loginError: null,
};
